export default __webpack_public_path__ + "static/media/S.659efc6a.png";